export const data = [
  {
    'CWE-ID': 5,
    'CWE Name': 'J2EE Misconfiguration: Data Transmission Without Encryption',
    'NIST-ID': 'SC-8',
    Rev: 4,
    'NIST Name': 'Transmission Confidentiality and Integrity'
  },
  {
    'CWE-ID': 6,
    'CWE Name': ' J2EE Misconfiguration: Insufficient Session-ID Length',
    'NIST-ID': 'SC-23',
    Rev: 4,
    'NIST Name': 'Session Authenticity'
  },
  {
    'CWE-ID': 7,
    'CWE Name': ' J2EE Misconfiguration: Missing Custom Error Page',
    'NIST-ID': 'SI-11',
    Rev: 4,
    'NIST Name': 'Error Handling'
  },
  {
    'CWE-ID': 8,
    'CWE Name': ' J2EE Misconfiguration: Entity Bean Declared Remote',
    'NIST-ID': 'AC-3',
    Rev: 4,
    'NIST Name': 'Access Enforcement'
  },
  {
    'CWE-ID': 9,
    'CWE Name':
      ' J2EE Misconfiguration: Weak Access Permissions for EJB Methods',
    'NIST-ID': 'AC-3',
    Rev: 4,
    'NIST Name': 'Access Enforcement'
  },
  {
    'CWE-ID': 11,
    'CWE Name': ' ASP.NET Misconfiguration: Creating Debug Binary',
    'NIST-ID': 'SI-11',
    Rev: 4,
    'NIST Name': 'Error Handling'
  },
  {
    'CWE-ID': 14,
    'CWE Name': ' Compiler Removal of Code to Clear Buffers',
    'NIST-ID': 'SI-16',
    Rev: 4,
    'NIST Name': 'Memory Protection'
  },
  {
    'CWE-ID': 15,
    'CWE Name': ' External Control of System or Configuration Setting',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 20,
    'CWE Name': ' Improper Input Validation',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 22,
    'CWE Name':
      " Improper Limitation of a Pathname to a Restricted Directory ('Path Traversal')",
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 23,
    'CWE Name': ' Relative Path Traversal',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 36,
    'CWE Name': ' Absolute Path Traversal',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 73,
    'CWE Name': ' External Control of File Name or Path',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 77,
    'CWE Name':
      " Improper Neutralization of Special Elements used in a Command ('Command Injection')",
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 78,
    'CWE Name':
      " Improper Neutralization of Special Elements used in an OS Command ('OS Command Injection')",
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 79,
    'CWE Name':
      " Improper Neutralization of Input During Web Page Generation ('Cross-site Scripting')",
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 89,
    'CWE Name':
      " Improper Neutralization of Special Elements used in an SQL Command ('SQL Injection')",
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 90,
    'CWE Name':
      " Improper Neutralization of Special Elements used in an LDAP Query ('LDAP Injection')",
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 91,
    'CWE Name': ' XML Injection (aka Blind XPath Injection)',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 94,
    'CWE Name': " Improper Control of Generation of Code ('Code Injection')",
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 95,
    'CWE Name':
      " Improper Neutralization of Directives in Dynamically Evaluated Code ('Eval Injection')",
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 99,
    'CWE Name':
      " Improper Control of Resource Identifiers ('Resource Injection')",
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 101,
    'CWE Name': ' Struts Validation Problems',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 102,
    'CWE Name': ' Struts: Duplicate Validation Forms',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 103,
    'CWE Name': ' Struts: Incomplete validate() Method Definition',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 104,
    'CWE Name': ' Struts: Form Bean Does Not Extend Validation Class',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 105,
    'CWE Name': ' Struts: Form Field Without Validator',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 106,
    'CWE Name': ' Struts: Plug-in Framework not in Use',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 107,
    'CWE Name': ' Struts: Unused Validation Form',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 108,
    'CWE Name': ' Struts: Unvalidated Action Form',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 109,
    'CWE Name': ' Struts: Validator Turned Off',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 110,
    'CWE Name': ' Struts: Validator Without Form Field',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 111,
    'CWE Name': ' Direct Use of Unsafe JNI',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 112,
    'CWE Name': ' Missing XML Validation',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 113,
    'CWE Name':
      " Improper Neutralization of CRLF Sequences in HTTP Headers ('HTTP Response Splitting')",
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 114,
    'CWE Name': ' Process Control',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 117,
    'CWE Name': ' Improper Output Neutralization for Logs',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 119,
    'CWE Name':
      ' Improper Restriction of Operations within the Bounds of a Memory Buffer',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 120,
    'CWE Name':
      " Buffer Copy without Checking Size of Input ('Classic Buffer Overflow')",
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 125,
    'CWE Name': ' Out-of-bounds Read',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 126,
    'CWE Name': ' Buffer Over-read',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 129,
    'CWE Name': ' Improper Validation of Array Index',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 131,
    'CWE Name': ' Incorrect Calculation of Buffer Size',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 134,
    'CWE Name': ' Uncontrolled Format String',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 170,
    'CWE Name': ' Improper Null Termination',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 176,
    'CWE Name': ' Improper Handling of Unicode Encoding',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 185,
    'CWE Name': ' Incorrect Regular Expression',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 189,
    'CWE Name': ' Numeric Errors',
    'NIST-ID': 'SA-11',
    Rev: 4,
    'NIST Name': 'Developer Security Testing and Evaluation'
  },
  {
    'CWE-ID': 190,
    'CWE Name': ' Integer Overflow or Wraparound',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 195,
    'CWE Name': ' Signed to Unsigned Conversion Error',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 200,
    'CWE Name': ' Information Exposure',
    'NIST-ID': 'SC-8',
    Rev: 4,
    'NIST Name': 'Transmission Confidentiality and Integrity'
  },
  {
    'CWE-ID': 209,
    'CWE Name': ' Information Exposure Through an Error Message',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 215,
    'CWE Name': ' Information Exposure Through Debug Information',
    'NIST-ID': 'SI-11',
    Rev: 4,
    'NIST Name': 'Error Handling'
  },
  {
    'CWE-ID': 226,
    'CWE Name': ' Sensitive Information Uncleared Before Release',
    'NIST-ID': 'SC-4',
    Rev: 4,
    'NIST Name': 'Information in Shared Resources'
  },
  {
    'CWE-ID': 235,
    'CWE Name': ' Improper Handling of Extra Parameters',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 242,
    'CWE Name': ' Use of Inherently Dangerous Function',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 243,
    'CWE Name': ' Creation of chroot Jail Without Changing Working Directory',
    'NIST-ID': 'AC-3',
    Rev: 4,
    'NIST Name': 'Access Enforcement'
  },
  {
    'CWE-ID': 244,
    'CWE Name': ' Improper Cleaning of Heap Memory',
    'NIST-ID': 'SC-4',
    Rev: 4,
    'NIST Name': 'Information in Shared Resources'
  },
  {
    'CWE-ID': 245,
    'CWE Name': ' J2EE Bad Practices: Direct Management of Connections',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 246,
    'CWE Name': ' J2EE Bad Practices: Direct Use of Sockets',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 248,
    'CWE Name': ' Uncaught Exception',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 250,
    'CWE Name': ' Execution with Unnecessary Privileges',
    'NIST-ID': 'AC-6',
    Rev: 4,
    'NIST Name': 'Least Privilege: Privilege Levels for Code Execution'
  },
  {
    'CWE-ID': 251,
    'CWE Name': ' Often Misused: String Management',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 252,
    'CWE Name': ' Unchecked Return Value',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 256,
    'CWE Name': ' Plaintext Storage of a Password',
    'NIST-ID': 'SC-28',
    Rev: 4,
    'NIST Name': 'Protection of Information at Rest'
  },
  {
    'CWE-ID': 257,
    'CWE Name': ' Storing Passwords in a Recoverable Format',
    'NIST-ID': 'IA-5',
    Rev: 4,
    'NIST Name': 'Authenticator Management'
  },
  {
    'CWE-ID': 258,
    'CWE Name': ' Empty Password in Configuration File',
    'NIST-ID': 'SC-28',
    Rev: 4,
    'NIST Name': 'Protection of Information at Rest'
  },
  {
    'CWE-ID': 259,
    'CWE Name': ' Use of Hard-coded Password',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 260,
    'CWE Name': ' Password in Configuration File',
    'NIST-ID': 'SC-28',
    Rev: 4,
    'NIST Name': 'Protection of Information at Rest'
  },
  {
    'CWE-ID': 261,
    'CWE Name': ' Weak Cryptography for Passwords',
    'NIST-ID': 'SC-13',
    Rev: 4,
    'NIST Name': 'Cryptographic Protection'
  },
  {
    'CWE-ID': 262,
    'CWE Name': ' Not Using Password Aging',
    'NIST-ID': 'IA-5',
    Rev: 4,
    'NIST Name': 'Authenticator Management'
  },
  {
    'CWE-ID': 263,
    'CWE Name': ' Password Aging with Long Expiration',
    'NIST-ID': 'IA-5',
    Rev: 4,
    'NIST Name': 'Authenticator Management'
  },
  {
    'CWE-ID': 265,
    'CWE Name': ' Privilege / Sandbox Issues',
    'NIST-ID': 'AC-6',
    Rev: 4,
    'NIST Name': 'Least Privilege'
  },
  {
    'CWE-ID': 269,
    'CWE Name': ' Improper Privilege Management',
    'NIST-ID': 'AC-4',
    Rev: 4,
    'NIST Name': 'Information Flow Enforcement'
  },
  {
    'CWE-ID': 272,
    'CWE Name': ' Least Privilege Violation',
    'NIST-ID': 'AC-6',
    Rev: 4,
    'NIST Name': 'Least Privilege: Privilege Levels for Code Execution -8'
  },
  {
    'CWE-ID': 275,
    'CWE Name': ' Permission Issues',
    'NIST-ID': 'AC-3',
    Rev: 4,
    'NIST Name': 'Access Enforcement'
  },
  {
    'CWE-ID': 284,
    'CWE Name': ' Improper Access Control',
    'NIST-ID': 'AC-3',
    Rev: 4,
    'NIST Name': 'Access Enforcement'
  },
  {
    'CWE-ID': 285,
    'CWE Name': ' Improper Authorization',
    'NIST-ID': 'AC-3',
    Rev: 4,
    'NIST Name': 'Access Enforcement'
  },
  {
    'CWE-ID': 288,
    'CWE Name': ' Authentication Bypass Using an Alternate Path or Channel',
    'NIST-ID': 'IA-8',
    Rev: 4,
    'NIST Name': 'Identification and Authentication (Non-Organizational Users)'
  },
  {
    'CWE-ID': 297,
    'CWE Name': ' Improper Validation of Certificate with Host Mismatch',
    'NIST-ID': 'SC-8',
    Rev: 4,
    'NIST Name': 'Transmission Confidentiality and Integrity'
  },
  {
    'CWE-ID': 302,
    'CWE Name': ' Authentication Bypass by Assumed-Immutable Data',
    'NIST-ID': 'SC-23',
    Rev: 4,
    'NIST Name': 'Session Authenticity'
  },
  {
    'CWE-ID': 305,
    'CWE Name': ' Authentication Bypass by Primary Weakness',
    'NIST-ID': 'IA-8',
    Rev: 4,
    'NIST Name': 'Identification and Authentication (Non-Organizational Users)'
  },
  {
    'CWE-ID': 306,
    'CWE Name': ' Missing Authentication for Critical Function',
    'NIST-ID': 'AC-3',
    Rev: 4,
    'NIST Name': 'Access Enforcement'
  },
  {
    'CWE-ID': 307,
    'CWE Name': ' Improper Restriction of Excessive Authentication Attempts',
    'NIST-ID': 'AC-7',
    Rev: 4,
    'NIST Name': 'Unsuccessful Logon Attempts'
  },
  {
    'CWE-ID': 310,
    'CWE Name': ' Cryptographic Issues',
    'NIST-ID': 'SC-13',
    Rev: 4,
    'NIST Name': 'Cryptographic Protection'
  },
  {
    'CWE-ID': 311,
    'CWE Name': ' Missing Encryption of Sensitive Data',
    'NIST-ID': 'SC-8',
    Rev: 4,
    'NIST Name': 'Transmission Confidentiality and Integrity'
  },
  {
    'CWE-ID': 321,
    'CWE Name': ' Use of Hard-coded Cryptographic Key',
    'NIST-ID': 'SC-12',
    Rev: 4,
    'NIST Name': 'Cryptographic Key Establishment and Management'
  },
  {
    'CWE-ID': 325,
    'CWE Name': ' Missing Required Cryptographic Step',
    'NIST-ID': 'SC-13',
    Rev: 4,
    'NIST Name': 'Cryptographic Protection'
  },
  {
    'CWE-ID': 326,
    'CWE Name': ' Inadequate Encryption Strength',
    'NIST-ID': 'SC-12',
    Rev: 4,
    'NIST Name': 'Cryptographic Key Establishment and Management'
  },
  {
    'CWE-ID': 327,
    'CWE Name': ' Use of a Broken or Risky Cryptographic Algorithm',
    'NIST-ID': 'SC-13',
    Rev: 4,
    'NIST Name': 'Cryptographic Protection'
  },
  {
    'CWE-ID': 328,
    'CWE Name': ' Reversible One-Way Hash',
    'NIST-ID': 'SC-13',
    Rev: 4,
    'NIST Name': 'Cryptographic Protection'
  },
  {
    'CWE-ID': 329,
    'CWE Name': ' Not Using a Random IV with CBC Mode',
    'NIST-ID': 'SC-12',
    Rev: 4,
    'NIST Name': 'Cryptographic Key Establishment and Management'
  },
  {
    'CWE-ID': 330,
    'CWE Name': ' Use of Insufficiently Random Values',
    'NIST-ID': 'SC-13',
    Rev: 4,
    'NIST Name': 'Cryptographic Protection'
  },
  {
    'CWE-ID': 331,
    'CWE Name': ' Insufficient Entropy',
    'NIST-ID': 'SC-13',
    Rev: 4,
    'NIST Name': 'Cryptographic Protection'
  },
  {
    'CWE-ID': 335,
    'CWE Name': ' PRNG Seed Error',
    'NIST-ID': 'SC-13',
    Rev: 4,
    'NIST Name': 'Cryptographic Protection'
  },
  {
    'CWE-ID': 336,
    'CWE Name': ' Same Seed in PRNG',
    'NIST-ID': 'SC-13',
    Rev: 4,
    'NIST Name': 'Cryptographic Protection'
  },
  {
    'CWE-ID': 338,
    'CWE Name':
      ' Use of Cryptographically Weak Pseudo-Random Number Generator (PRNG)',
    'NIST-ID': 'SC-13',
    Rev: 4,
    'NIST Name': 'Cryptographic Protection'
  },
  {
    'CWE-ID': 345,
    'CWE Name': ' Insufficient Verification of Data Authenticity',
    'NIST-ID': 'SC-8',
    Rev: 4,
    'NIST Name': 'Transmission Confidentiality and Integrity'
  },
  {
    'CWE-ID': 350,
    'CWE Name':
      ' Reliance on Reverse DNS Resolution for a Security-Critical Function',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 352,
    'CWE Name': ' Cross-Site Request Forgery (CSRF)',
    'NIST-ID': 'AC-3',
    Rev: 4,
    'NIST Name': 'Access Enforcement'
  },
  {
    'CWE-ID': 358,
    'CWE Name': ' Improperly Implemented Security Check for Standard',
    'NIST-ID': 'AC-3',
    Rev: 4,
    'NIST Name': 'Access Enforcement'
  },
  {
    'CWE-ID': 359,
    'CWE Name': " Exposure of Private Information ('Privacy Violation')",
    'NIST-ID': 'SC-28',
    Rev: 4,
    'NIST Name': 'Protection of Information at Rest'
  },
  {
    'CWE-ID': 362,
    'CWE Name':
      " Concurrent Execution using Shared Resource with Improper Synchronization ('Race Condition')",
    'NIST-ID': 'SC-4',
    Rev: 4,
    'NIST Name': 'Information in Shared Resources'
  },
  {
    'CWE-ID': 364,
    'CWE Name': ' Signal Handler Race Condition',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 369,
    'CWE Name': ' Divide by Zero',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 377,
    'CWE Name': ' Insecure Temporary File',
    'NIST-ID': 'SC-4',
    Rev: 4,
    'NIST Name': 'Information in Shared Resources (P1)'
  },
  {
    'CWE-ID': 382,
    'CWE Name': ' J2EE Bad Practices: Use of System.exit()',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 383,
    'CWE Name': ' J2EE Bad Practices: Direct Use of Threads',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 384,
    'CWE Name': ' Session Fixation',
    'NIST-ID': 'SC-23',
    Rev: 4,
    'NIST Name': 'Session Authenticity'
  },
  {
    'CWE-ID': 388,
    'CWE Name': ' Error Handling',
    'NIST-ID': 'SI-11',
    Rev: 4,
    'NIST Name': 'Error Handling'
  },
  {
    'CWE-ID': 391,
    'CWE Name': ' Unchecked Error Condition',
    'NIST-ID': 'SI-11',
    Rev: 4,
    'NIST Name': 'Error Handling'
  },
  {
    'CWE-ID': 395,
    'CWE Name':
      ' Use of NullPointerException Catch to Detect NULL Pointer Dereference',
    'NIST-ID': 'SI-11',
    Rev: 4,
    'NIST Name': 'Error Handling'
  },
  {
    'CWE-ID': 396,
    'CWE Name': ' Declaration of Catch for Generic Exception',
    'NIST-ID': 'SI-11',
    Rev: 4,
    'NIST Name': 'Error Handling'
  },
  {
    'CWE-ID': 397,
    'CWE Name': ' Declaration of Throws for Generic Exception',
    'NIST-ID': 'SI-11',
    Rev: 4,
    'NIST Name': 'Error Handling'
  },
  {
    'CWE-ID': 398,
    'CWE Name': ' Indicator of Poor Code Quality',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 400,
    'CWE Name': " Uncontrolled Resource Consumption ('Resource Exhaustion')",
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 401,
    'CWE Name': ' Improper Release of Memory Before Removing Last Reference',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 404,
    'CWE Name': ' Improper Resource Shutdown or Release',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 415,
    'CWE Name': ' Double Free',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 416,
    'CWE Name': ' Use after Free',
    'NIST-ID': 'SC-4',
    Rev: 4,
    'NIST Name': 'Information in Shared Resources'
  },
  {
    'CWE-ID': 434,
    'CWE Name': ' Unrestricted Upload of File with Dangerous Type',
    'NIST-ID': 'AC-6',
    Rev: 4,
    'NIST Name': 'Least Privilege: Privilege Levels for Code Execution'
  },
  {
    'CWE-ID': 444,
    'CWE Name':
      " Inconsistent Interpretation of HTTP Requests ('HTTP Request Smuggling')",
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 457,
    'CWE Name': ' Use of Uninitialized Variable',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 466,
    'CWE Name': ' Return of Pointer Value Outside of Expected Range',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 470,
    'CWE Name':
      " Use of Externally-Controlled Input to Select Classes or Code ('Unsafe Reflection')",
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 471,
    'CWE Name': ' Modification of Assumed-Immutable DATA (MAID)',
    'NIST-ID': 'AC-3',
    Rev: 4,
    'NIST Name': 'Access Enforcement'
  },
  {
    'CWE-ID': 474,
    'CWE Name': ' Use of Function with Inconsistent Implementations',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 475,
    'CWE Name': ' Undefined Behavior for Input to API',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 476,
    'CWE Name': ' NULL Pointer Dereference',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 477,
    'CWE Name': ' Use of Obsolete Functions',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 478,
    'CWE Name': ' Missing Default Case in Switch Statement',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 492,
    'CWE Name': ' Use of Inner Class Containing Sensitive Data',
    'NIST-ID': 'AC-3',
    Rev: 4,
    'NIST Name': 'Access Enforcement'
  },
  {
    'CWE-ID': 493,
    'CWE Name': ' Critical Public Variable Without Final Modifier',
    'NIST-ID': 'SI-11',
    Rev: 4,
    'NIST Name': 'Error Handling'
  },
  {
    'CWE-ID': 494,
    'CWE Name': ' Download of Code Without Integrity Check',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 495,
    'CWE Name': ' Private Array-Typed Field Returned From A Public Method',
    'NIST-ID': 'AC-3',
    Rev: 4,
    'NIST Name': 'Access Enforcement'
  },
  {
    'CWE-ID': 497,
    'CWE Name': ' Exposure of System Data to an Unauthorized Control Sphere',
    'NIST-ID': 'SI-11',
    Rev: 4,
    'NIST Name': 'Error Handling'
  },
  {
    'CWE-ID': 501,
    'CWE Name': ' Trust Boundary Violation',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 502,
    'CWE Name': ' Deserialization of Untrusted Data',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation '
  },
  {
    'CWE-ID': 521,
    'CWE Name': ' Weak Password Requirements',
    'NIST-ID': 'IA-5',
    Rev: 4,
    'NIST Name': 'Authenticator Management : -1 Password-based Authentication'
  },
  {
    'CWE-ID': 522,
    'CWE Name': ' Insufficiently Protected Credentials',
    'NIST-ID': 'SC-8',
    Rev: 4,
    'NIST Name': 'Transmission Confidentiality and Integrity'
  },
  {
    'CWE-ID': 539,
    'CWE Name': ' Information Exposure Through Persistent Cookies',
    'NIST-ID': 'SC-23',
    Rev: 4,
    'NIST Name': 'Session Authenticity'
  },
  {
    'CWE-ID': 546,
    'CWE Name': ' Suspicious Comment',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 557,
    'CWE Name': ' Concurrency Issues',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 560,
    'CWE Name': ' Use of umask() with chmod-style Argument',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 561,
    'CWE Name': ' Dead Code',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 562,
    'CWE Name': ' Return of Stack Variable Address',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 563,
    'CWE Name': ' Assigntment to Variable without Use',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 564,
    'CWE Name': ' SQL Injection: Hibernate',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 566,
    'CWE Name': ' Authorization Bypass Through User-Controlled SQL Primary Key',
    'NIST-ID': 'AC-3',
    Rev: 4,
    'NIST Name': 'Access Enforcement'
  },
  {
    'CWE-ID': 568,
    'CWE Name': ' finalize() Method without super.finalize()',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 574,
    'CWE Name': ' EJB Bad Practices: Use of Synchronization Primitives',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 575,
    'CWE Name': ' EJB Bad Practices: Use of AWT Swing',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 576,
    'CWE Name': ' EJB Bad Practices: Use of java I/O',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 577,
    'CWE Name': ' EJB Bad Practices: Use of Sockets',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 578,
    'CWE Name': ' EJB Bad Practices: Use of Class Loader',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 579,
    'CWE Name':
      ' J2EE Bad Practices: Non-serializable Object Stored in Session',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 580,
    'CWE Name': ' clone() Method Without super.clone()',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 581,
    'CWE Name':
      ' Object Model Violation: Just One of Equals and Hashcode Defined',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 582,
    'CWE Name': ' Array Declared Public',
    'NIST-ID': 'AC-3',
    Rev: 4,
    'NIST Name': 'Access Enforcement'
  },
  {
    'CWE-ID': 583,
    'CWE Name': ' finalize() Method Declared Public',
    'NIST-ID': 'AC-3',
    Rev: 4,
    'NIST Name': 'Access Enforcement'
  },
  {
    'CWE-ID': 584,
    'CWE Name': ' Return Inside Finally Block',
    'NIST-ID': 'SI-11',
    Rev: 4,
    'NIST Name': 'Error Handling'
  },
  {
    'CWE-ID': 586,
    'CWE Name': ' Explicit Call to Finalize()',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 590,
    'CWE Name': ' Free of Memory not on the Heap',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 591,
    'CWE Name': ' Sensitive Data Storage in Improperly Locked Memory',
    'NIST-ID': 'SC-4',
    Rev: 4,
    'NIST Name': 'Information in Shared Resources'
  },
  {
    'CWE-ID': 601,
    'CWE Name': " URL Redirection to Untrusted Site ('Open Redirect')",
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 607,
    'CWE Name': ' Public Static Final Field References Mutable Object',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 609,
    'CWE Name': ' Double-Checked Locking',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 611,
    'CWE Name':
      " Improper Restriction of XML External Entity Reference ('XXE')",
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 613,
    'CWE Name': ' Insufficient Session Expiration',
    'NIST-ID': 'AC-12',
    Rev: 4,
    'NIST Name': 'Session Termination'
  },
  {
    'CWE-ID': 614,
    'CWE Name': " Sensitive Cookie in HTTPS Session Without 'Secure' Attribute",
    'NIST-ID': 'SC-8',
    Rev: 4,
    'NIST Name': 'Transmission Confidentiality and Integrity'
  },
  {
    'CWE-ID': 615,
    'CWE Name': ' Information Exposure Through Comments',
    'NIST-ID': 'AC-3',
    Rev: 4,
    'NIST Name': 'Access Enforcement : -5 Security-Relevant Information'
  },
  {
    'CWE-ID': 639,
    'CWE Name': ' Authorization Bypass Through User-Controlled Key',
    'NIST-ID': 'AC-3',
    Rev: 4,
    'NIST Name': 'Access Enforcement'
  },
  {
    'CWE-ID': 642,
    'CWE Name': ' External Control of Critical State Data',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 643,
    'CWE Name':
      " Improper Neutralization of Data within XPath Expressions ('XPath Injection')",
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 651,
    'CWE Name': ' Information Exposure Through WSDL File',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 652,
    'CWE Name':
      " Improper Neutralization of Data within XQuery Expressions ('XQuery Injection')",
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 662,
    'CWE Name': ' Improper Synchonization',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 667,
    'CWE Name': ' Improper Locking',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 676,
    'CWE Name': ' Use of Potentially Dangerous Function',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 690,
    'CWE Name': ' Unchecked Return Value to NULL Pointer Dereference',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 691,
    'CWE Name': ' Insufficient Control Flow Management',
    'NIST-ID': 'SI-11',
    Rev: 4,
    'NIST Name': 'Error Handling'
  },
  {
    'CWE-ID': 693,
    'CWE Name': ' Protection Mechanism Failure',
    'NIST-ID': 'IA-5',
    Rev: 4,
    'NIST Name': 'Authenticator Management'
  },
  {
    'CWE-ID': 694,
    'CWE Name': ' Use of Multiple Resources with Duplicate Identifier',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 732,
    'CWE Name': ' Incorrect Permission Assignment for Critical Resource',
    'NIST-ID': 'AC-3',
    Rev: 4,
    'NIST Name': 'Access Enforcement'
  },
  {
    'CWE-ID': 733,
    'CWE Name':
      ' Compiler Optimization Removal or Modification of Security-critical Code',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 759,
    'CWE Name': ' Use of a One-Way Hash without a Salt',
    'NIST-ID': 'SC-13',
    Rev: 4,
    'NIST Name': 'Cryptographic Protection'
  },
  {
    'CWE-ID': 760,
    'CWE Name': ' Use of a One-Way Hash with a Predictable Salt',
    'NIST-ID': 'SC-13',
    Rev: 4,
    'NIST Name': 'Cryptographic Protection'
  },
  {
    'CWE-ID': 776,
    'CWE Name':
      " Improper Restriction of Recursive Entity References in DTDs ('XML Entity Expansion')",
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 780,
    'CWE Name': ' Use of RSA Algorithm without OAEP',
    'NIST-ID': 'SC-13',
    Rev: 4,
    'NIST Name': 'Cryptographic Protection'
  },
  {
    'CWE-ID': 785,
    'CWE Name':
      ' Use of Path Manipulation Function without Maximum-sized Buffer',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 787,
    'CWE Name': ' Out-of-bounds Write',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 798,
    'CWE Name': ' Use of Hard-coded Credentials',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 805,
    'CWE Name': ' Buffer Access with Incorrect Length Value',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 807,
    'CWE Name': ' Reliance on Untrusted Inputs in a Security Decision',
    'NIST-ID': 'SC-23',
    Rev: 4,
    'NIST Name': 'Session Authenticity'
  },
  {
    'CWE-ID': 820,
    'CWE Name': ' Missing Synchronization',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 821,
    'CWE Name': ' Incorrect Synchronization',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 829,
    'CWE Name': ' Inclusion of Functionality from Untrusted Control Sphere',
    'NIST-ID': '',
    Rev: 4,
    'NIST Name': ''
  },
  {
    'CWE-ID': 862,
    'CWE Name': ' Missing Authorization',
    'NIST-ID': 'AC-3',
    Rev: 4,
    'NIST Name': 'Access Enforcement'
  },
  {
    'CWE-ID': 863,
    'CWE Name': ' Incorrect Authorization',
    'NIST-ID': 'AC-3',
    Rev: 4,
    'NIST Name': 'Access Enforcement'
  },
  {
    'CWE-ID': 915,
    'CWE Name':
      ' Improperly Controlled Modification of Dynamically-Determined Object Attributes',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  },
  {
    'CWE-ID': 916,
    'CWE Name': ' Use of Password Hash With Insufficient Computational Effort',
    'NIST-ID': 'SC-13',
    Rev: 4,
    'NIST Name': 'Cryptographic Protection'
  },
  {
    'CWE-ID': 918,
    'CWE Name': ' Server-Side Request Forgery (SSRF)',
    'NIST-ID': 'SI-10',
    Rev: 4,
    'NIST Name': 'Information Input Validation'
  }
];
